import * as commonData from "../Common";
import * as actionType from "../constants";
export const editFilter = (input) => async (dispatch) => {
  let apiUrl = commonData.commonData().apiUrl;
  const resp = await fetch(`${apiUrl}update-custom-filter`, {
    method: "post",
    body: JSON.stringify(input),
  });

  const responseData = await resp.json();
  if (responseData.code === 200) {
    dispatch({
      type: actionType.EDIT_FILTER_HANDLER,
      payload: {
        message: responseData.message,
        code: responseData.code,
        data: input,
      },
    });
  } else {
  }
};
